import { useMutation } from '@tanstack/react-query';

import { useConfirmationModalStore } from '../../hooks/useConfirmationModal';
import { ConfirmationModal } from './ConfirmationModal';

export function ConfirmationModalRenderer() {
    const { isOpen, modalProps, closeConfirmationModal } = useConfirmationModalStore();

    const onConfirmMutation = useMutation({
        mutationFn: async () => {
            await modalProps?.onConfirm?.();
        },
    });

    return (
        <ConfirmationModal
            title={modalProps?.title}
            icon={null}
            okButton={{
                onClick: () => onConfirmMutation.mutate(undefined, { onSuccess: closeConfirmationModal }),
                loading: onConfirmMutation.isPending,
                children: modalProps?.confirmButtonText,
            }}
            cancelButton={{
                onClick: () => {
                    modalProps?.onCancel?.();
                    closeConfirmationModal();
                },
                children: modalProps?.cancelButtonText,
            }}
            open={isOpen}
            onClose={closeConfirmationModal}
        >
            {modalProps?.content}
        </ConfirmationModal>
    );
}
